// extracted by mini-css-extract-plugin
module.exports = {"gallery_pokemon":"Home_gallery_pokemon__1lEW0"};